import { render, staticRenderFns } from "./StatisticsTrades.vue?vue&type=template&id=1221ce98&scoped=true&"
import script from "./StatisticsTrades.vue?vue&type=script&lang=js&"
export * from "./StatisticsTrades.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTrades.vue?vue&type=style&index=0&id=1221ce98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221ce98",
  null
  
)

export default component.exports